import { render, staticRenderFns } from "./ComicList.vue?vue&type=template&id=2de96ec3&scoped=true&"
import script from "./ComicList.vue?vue&type=script&lang=js&"
export * from "./ComicList.vue?vue&type=script&lang=js&"
import style0 from "./ComicList.vue?vue&type=style&index=0&id=2de96ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de96ec3",
  null
  
)

export default component.exports